export default {

	Info: 'info',
	Error: 'error',
	Success: 'success',
	Warning: 'warning'

};